import React, { useState, useEffect, useContext } from "react";
import { ApiUrlContext } from "../App";

const InstructorPage = () => {
  const apiUrl = useContext(ApiUrlContext);
  
  // STATE TANIMLARI
  const [myCourses, setMyCourses] = useState([]);
  const [selectedCourse, setSelectedCourse] = useState(null);
  const [courseLessons, setCourseLessons] = useState([]);
  const [enrolledStudents, setEnrolledStudents] = useState([]);
  const [assignments, setAssignments] = useState([]);
  const [submissions, setSubmissions] = useState([]);
  const [submissionLoading, setSubmissionLoading] = useState(false);
  const [gradeInputs, setGradeInputs] = useState({});
  const [assignEmail, setAssignEmail] = useState("");
  const [newAssignment, setNewAssignment] = useState({ 
    title: "", 
    description: "", 
    dueDate: "", 
  });
  const [newLesson, setNewLesson] = useState({
    title: "",
    description: "",
    videoUrl: "",
    duration: "",
    order: 1
  });
  
  // YOKLAMA STATE'LERİ
  const [selectedLessonForAttendance, setSelectedLessonForAttendance] = useState(null);
  const [attendanceStatus, setAttendanceStatus] = useState({});
  const [showAttendanceModal, setShowAttendanceModal] = useState(false);
  const [attendanceLoading, setAttendanceLoading] = useState(false);
  
  // YOKLAMA GEÇMİŞİ VE İSTATİSTİKLER
  const [courseAttendance, setCourseAttendance] = useState([]);
  const [attendanceStats, setAttendanceStats] = useState({
    totalLessons: 0,
    totalAttendanceRecords: 0,
    averageAttendance: 0
  });
  const [loadingAttendance, setLoadingAttendance] = useState(false);
  
  const [activeTab, setActiveTab] = useState("courses");
  const [loading, setLoading] = useState(false);
  const [viewingSubmissions, setViewingSubmissions] = useState(null);
  const [debug, setDebug] = useState({}); // Hata ayıklama için

  // Yoklama sistemi, alan yoksa varsayılan olarak açık kabul edilir
  const attendanceEnabled = selectedCourse ? selectedCourse.hasAttendanceSystem !== false : false;

  useEffect(() => {
    fetchInstructorData();
  }, []);

  useEffect(() => {
    if (selectedCourse) {
      fetchCourseAttendance();
    }
  }, [selectedCourse]);

  // EĞİTMEN VERİLERİNİ ÇEK
  const fetchInstructorData = async () => {
    setLoading(true);
    try {
      const token = localStorage.getItem("token");
      if (!token) {
        console.error("Token bulunamadı");
        return;
      }

      const coursesResponse = await fetch(`${apiUrl}/instructor/courses`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      
      if (coursesResponse.ok) {
        const coursesData = await coursesResponse.json();
        setMyCourses(coursesData);
        setDebug(prev => ({ ...prev, coursesLoaded: true, courseCount: coursesData.length }));
      } else {
        console.error("Kurslar yüklenemedi:", coursesResponse.status);
        setDebug(prev => ({ ...prev, coursesError: coursesResponse.status }));
      }
    } catch (error) {
      console.error("Eğitmen verisi yüklenirken hata:", error);
      setDebug(prev => ({ ...prev, fetchError: error.message }));
    } finally {
      setLoading(false);
    }
  };

  // KURS YOKLAMA VERİLERİNİ ÇEK
  const fetchCourseAttendance = async () => {
    if (!selectedCourse) return;
    
    setLoadingAttendance(true);
    try {
      const token = localStorage.getItem("token");
      const response = await fetch(
        `${apiUrl}/instructor/courses/${selectedCourse._id}/attendance`,
        {
          headers: { Authorization: `Bearer ${token}` }
        }
      );
      
      if (response.ok) {
        const data = await response.json();
        setCourseAttendance(data.attendance || []);
        setAttendanceStats(data.stats || {
          totalLessons: 0,
          totalAttendanceRecords: 0,
          averageAttendance: 0
        });
      }
    } catch (error) {
      console.error("Yoklama verileri yüklenirken hata:", error);
    } finally {
      setLoadingAttendance(false);
    }
  };

  // KURS DERSLERİNİ ÇEK
  const fetchCourseLessons = async (courseId) => {
    setLoading(true);
    try {
      const token = localStorage.getItem("token");
      const response = await fetch(`${apiUrl}/instructor/courses/${courseId}/lessons`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      if (response.ok) {
        const lessonsData = await response.json();
        setCourseLessons(lessonsData);
        setDebug(prev => ({ ...prev, lessonsLoaded: true, lessonCount: lessonsData.length }));
      } else {
        console.error("Dersler yüklenemedi:", response.status);
      }
    } catch (error) {
      console.error("Dersler yüklenirken hata:", error);
    } finally {
      setLoading(false);
    }
  };

  // KAYITLI ÖĞRENCİLERİ ÇEK
  const fetchEnrolledStudents = async (courseId) => {
    setLoading(true);
    try {
      const token = localStorage.getItem("token");
      const response = await fetch(`${apiUrl}/instructor/courses/${courseId}/students`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      if (response.ok) {
        const studentsData = await response.json();
        setEnrolledStudents(studentsData);
        setDebug(prev => ({ ...prev, studentsLoaded: true, studentCount: studentsData.length }));
      }
    } catch (error) {
      console.error("Öğrenciler yüklenirken hata:", error);
    } finally {
      setLoading(false);
    }
  };

  // ÖDEVLERİ ÇEK
  const fetchAssignments = async (courseId) => {
    setLoading(true);
    try {
      const token = localStorage.getItem("token");
      const response = await fetch(`${apiUrl}/instructor/courses/${courseId}/assignments`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      if (response.ok) {
        const data = await response.json();
        setAssignments(data);
      }
    } catch (error) {
      console.error("Ödevler yüklenirken hata:", error);
    } finally {
      setLoading(false);
    }
  };

  // TESLİMLERİ ÇEK
  const fetchSubmissions = async (assignmentId) => {
    setSubmissionLoading(true);
    try {
      const token = localStorage.getItem('token');
      const res = await fetch(`${apiUrl}/assignments/${assignmentId}/submissions`, { 
        headers: { Authorization: `Bearer ${token}` } 
      });
      if (res.ok) {
        const data = await res.json();
        setSubmissions(data);
        const init = {};
        data.forEach(s => { 
          init[s._id] = { grade: s.grade || '', feedback: s.feedback || '' } 
        });
        setGradeInputs(init);
      } else {
        const err = await res.json();
        alert(err.error || 'Ödevlerin teslimleri alınamadı');
      }
    } catch (e) {
      console.error(e);
      alert('Sunucu hatası');
    } finally {
      setSubmissionLoading(false);
    }
  };

  // TESLİMLERİ GÖSTER/GİZLE
  const toggleSubmissions = async (assignment) => {
    if (viewingSubmissions === assignment._id) {
      setViewingSubmissions(null);
    } else {
      setViewingSubmissions(assignment._id);
      await fetchSubmissions(assignment._id);
    }
  };

  // NOT VER
  const handleGrade = async (submissionId) => {
    const input = gradeInputs[submissionId] || {};
    if (input.grade === '' && input.grade !== 0) {
      alert('Not girin');
      return;
    }
    try {
      const token = localStorage.getItem('token');
      const res = await fetch(`${apiUrl}/submissions/${submissionId}/grade`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
        body: JSON.stringify({ grade: input.grade, feedback: input.feedback })
      });
      if (res.ok) {
        const updated = await res.json();
        setSubmissions(prev => prev.map(s => s._id === updated._id ? updated : s));
        alert('Not kaydedildi');
      } else {
        const err = await res.json();
        alert(err.error || 'Not kaydedilemedi');
      }
    } catch (e) {
      console.error(e);
      alert('Sunucu hatası');
    }
  };

  // KURS SEÇ
  const handleCourseSelect = (course) => {
    console.log("Kurs seçildi:", course);
    setSelectedCourse(course);
    fetchCourseLessons(course._id);
    fetchEnrolledStudents(course._id);
    fetchAssignments(course._id);
    setActiveTab("lessons");
    setViewingSubmissions(null);
  };

  // DERS EKLE
  const handleCreateLesson = async (e) => {
    e.preventDefault();
    if (!selectedCourse) return;

    setLoading(true);
    try {
      const token = localStorage.getItem("token");
      const response = await fetch(`${apiUrl}/instructor/courses/${selectedCourse._id}/lessons`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`
        },
        body: JSON.stringify(newLesson)
      });

      if (response.ok) {
        const lesson = await response.json();
        setCourseLessons([...courseLessons, lesson]);
        setNewLesson({
          title: "",
          description: "",
          videoUrl: "",
          duration: "",
          order: courseLessons.length + 1
        });
        alert("Ders başarıyla eklendi!");
        // Dersleri yeniden yükle
        await fetchCourseLessons(selectedCourse._id);
        fetchCourseAttendance();
      } else {
        const error = await response.json();
        alert(error.error || "Ders eklenirken hata oluştu!");
      }
    } catch (error) {
      console.error("Ders ekleme hatası:", error);
      alert("Ders eklenirken hata oluştu!");
    } finally {
      setLoading(false);
    }
  };

  // DERS SİL
  const handleDeleteLesson = async (lessonId) => {
    if (!window.confirm("Bu dersi silmek istediğinizden emin misiniz?")) return;
    
    setLoading(true);
    try {
      const token = localStorage.getItem("token");
      const response = await fetch(`${apiUrl}/instructor/lessons/${lessonId}`, {
        method: "DELETE",
        headers: { Authorization: `Bearer ${token}` }
      });

      if (response.ok) {
        setCourseLessons(courseLessons.filter(lesson => lesson._id !== lessonId));
        alert("Ders başarıyla silindi!");
        fetchCourseAttendance();
      } else {
        alert("Ders silinirken hata oluştu!");
      }
    } catch (error) {
      console.error("Ders silme hatası:", error);
      alert("Ders silinirken hata oluştu!");
    } finally {
      setLoading(false);
    }
  };

  // ÖĞRENCİ ATA
  const handleAssignStudent = async (e) => {
    e.preventDefault();
    if (!selectedCourse || !assignEmail) return;
    setLoading(true);
    try {
      const token = localStorage.getItem("token");
      const response = await fetch(`${apiUrl}/instructor/courses/${selectedCourse._id}/assign-student`, {
        method: "POST",
        headers: { "Content-Type": "application/json", Authorization: `Bearer ${token}` },
        body: JSON.stringify({ email: assignEmail.trim() })
      });
      if (response.ok) {
        alert("Öğrenci kursa atandı (veya zaten kayıtlı).");
        setAssignEmail("");
        fetchEnrolledStudents(selectedCourse._id);
        fetchCourseAttendance();
      } else {
        const err = await response.json();
        alert(err.error || "Atama başarısız");
      }
    } catch (error) {
      console.error("Öğrenci atama hatası:", error);
      alert("Atama sırasında hata oluştu");
    } finally {
      setLoading(false);
    }
  };

  // ÖDEV OLUŞTUR
  const handleCreateAssignment = async (e) => {
    e.preventDefault();
    if (!selectedCourse || !newAssignment.title) return;
    setLoading(true);
    try {
      const token = localStorage.getItem("token");
      const payload = {
        title: newAssignment.title,
        description: newAssignment.description,
        dueDate: newAssignment.dueDate || null,
      };
      const response = await fetch(`${apiUrl}/instructor/courses/${selectedCourse._id}/assignments`, {
        method: "POST",
        headers: { "Content-Type": "application/json", Authorization: `Bearer ${token}` },
        body: JSON.stringify(payload)
      });
      if (response.ok) {
        const created = await response.json();
        setAssignments([...assignments, created]);
        setNewAssignment({ title: "", description: "", dueDate: "" });
        alert("Ödev oluşturuldu!");
      } else {
        const err = await response.json();
        alert(err.error || "Ödev oluşturulamadı");
      }
    } catch (error) {
      console.error("Ödev oluşturma hatası:", error);
      alert("Ödev oluşturulurken hata oluştu");
    } finally {
      setLoading(false);
    }
  };

  // YOKLAMA BAŞLAT - DÜZELTİLMİŞ
  const handleStartAttendance = (lessonId) => {
    console.log("Yoklama başlatılıyor - Ders ID:", lessonId);
    console.log("Seçili kurs:", selectedCourse);
    console.log("Dersler:", courseLessons);
    
    // Dersin var olduğundan emin ol
    const lesson = courseLessons.find(l => l._id === lessonId);
    if (!lesson) {
      console.error("Ders bulunamadı! Ders ID:", lessonId);
      alert("Ders bulunamadı! Lütfen sayfayı yenileyin.");
      return;
    }
    
    console.log("Ders bulundu:", lesson);
    
    // Öğrenci listesini kontrol et
    if (enrolledStudents.length === 0) {
      console.warn("Kayıtlı öğrenci yok!");
      alert("Bu kursta kayıtlı öğrenci bulunmuyor. Yoklama alınamaz.");
      return;
    }
    
    setSelectedLessonForAttendance(lessonId);
    setAttendanceStatus(
      enrolledStudents.reduce((accumulator, student) => {
        accumulator[student._id] = 'present';
        return accumulator;
      }, {})
    );
    setShowAttendanceModal(true);
    
    console.log("Modal açıldı, state güncellendi");
  };

  // YOKLAMA DURUMUNU DEĞİŞTİR
  const handleAttendanceChange = (studentId, status) => {
    console.log('Attendance change', { studentId, status });
    setAttendanceStatus(prev => ({
      ...prev,
      [studentId]: status
    }));
  };

  // YOKLAMAYI KAYDET - DÜZELTİLMİŞ
  const handleSaveAttendance = async () => {
    if (!selectedCourse || !selectedLessonForAttendance) {
      console.error("Kurs veya ders seçili değil");
      alert("Kurs veya ders seçili değil!");
      return;
    }
    
    // En az bir öğrenci işaretlendi mi kontrol et
    const markedCount = Object.keys(attendanceStatus).length;
    if (markedCount === 0) {
      alert("Lütfen en az bir öğrenci için yoklama işareti yapın!");
      return;
    }
    
    console.log("Yoklama kaydediliyor:", {
      courseId: selectedCourse._id,
      lessonId: selectedLessonForAttendance,
      attendance: attendanceStatus,
      markedCount: markedCount
    });
    
    setAttendanceLoading(true);
    try {
      const token = localStorage.getItem("token");
      
      // API URL'ini kontrol et - doğru endpoint'i kullan
      const apiEndpoint = `${apiUrl}/instructor/courses/${selectedCourse._id}/lessons/${selectedLessonForAttendance}/attendance`;
      
      console.log("API Endpoint:", apiEndpoint);
      
      const response = await fetch(apiEndpoint, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`
        },
        body: JSON.stringify({
          attendance: attendanceStatus
        })
      });
      
      console.log("Response status:", response.status);
      
      if (response.ok) {
        const data = await response.json();
        console.log("Response data:", data);
        
        if (data.success) {
          alert("Yoklama başarıyla kaydedildi!");
          setShowAttendanceModal(false);
          setSelectedLessonForAttendance(null);
          setAttendanceStatus({});
          // Yoklama verilerini yenile
          await fetchCourseAttendance();
        } else {
          alert(data.error || "Yoklama kaydedilemedi!");
        }
      } else {
        let errorMessage = "Yoklama kaydedilemedi!";
        try {
          const errorData = await response.json();
          console.error("Hata detayı:", errorData);
          errorMessage = errorData.error || errorMessage;
        } catch (e) {
          console.error("Hata yanıtı okunamadı:", e);
        }
        alert(errorMessage);
      }
    } catch (error) {
      console.error("Yoklama kaydedilirken hata:", error);
      alert("Yoklama kaydedilemedi: " + error.message);
    } finally {
      setAttendanceLoading(false);
    }
  };

  // ÖĞRENCİ YOKLAMA DURUMUNU HESAPLA
  const calculateStudentAttendance = (studentId) => {
    if (!courseAttendance.length) return { present: 0, absent: 0, total: 0, percentage: 0 };
    
    const studentAttendances = courseAttendance.filter(record => 
      record.attendance && record.attendance[studentId]
    );
    
    const presentCount = studentAttendances.filter(record => 
      record.attendance[studentId] === 'present'
    ).length;
    
    const absentCount = studentAttendances.filter(record => 
      record.attendance[studentId] === 'absent'
    ).length;
    
    const totalLessons = courseAttendance.length;
    const percentage = totalLessons > 0 ? Math.round((presentCount / totalLessons) * 100) : 0;
    
    return { present: presentCount, absent: absentCount, total: totalLessons, percentage };
  };

  // Dersler tab'ı
  const renderLessonsTab = () => (
    <div style={styles.card}>
      <h2 style={styles.cardTitle}>
        {selectedCourse.title} - Dersler ({courseLessons.length})
        {attendanceEnabled && (
          <span style={styles.attendanceSystemBadge}>
            Yoklama Aktif
          </span>
        )}
      </h2>
      
      
      
      {courseLessons.length === 0 ? (
        <div style={styles.emptyState}>
          Bu kursa henüz ders eklenmemiş.
        </div>
      ) : (
        <div style={styles.lessonsList}>
          {courseLessons
            .sort((a, b) => a.order - b.order)
            .map((lesson) => (
            <div key={lesson._id} style={styles.lessonCard}>
              <div style={styles.lessonContent}>
                <div style={styles.lessonHeader}>
                  <span style={styles.lessonNumber}>
                    {lesson.order}
                  </span>
                  <h4 style={styles.lessonTitle}>{lesson.title}</h4>
                  {attendanceEnabled && (
                    <span style={styles.attendanceBadge}>
                      Yoklama
                    </span>
                  )}
                </div>
                <p style={styles.lessonDescription}>{lesson.description}</p>
                <div style={styles.lessonMeta}>
                  <span>⏱️ {lesson.duration}</span>
                  {lesson.videoUrl && <span>Video var</span>}
                </div>
              </div>
              <div style={styles.lessonActions}>
                {attendanceEnabled && (
                  <button
                    onClick={() => {
                      console.log("Yoklama butonuna tıklandı - Ders:", lesson);
                      handleStartAttendance(lesson._id);
                    }}
                    style={styles.attendanceButton}
                    disabled={attendanceLoading || enrolledStudents.length === 0}
                    title={enrolledStudents.length === 0 ? "Kayıtlı öğrenci yok" : "Yoklama al"}
                  >
                    Yoklama Al
                  </button>
                )}
                <button
                  onClick={() => handleDeleteLesson(lesson._id)}
                  style={styles.deleteButton}
                  disabled={loading}
                >
                  Sil
                </button>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );

  // Öğrenci yoklama takibi tab'ı
  const renderAttendanceSection = () => (
    <div style={styles.card}>
      <h2 style={styles.cardTitle}>
        {selectedCourse.title} - Yoklama Takibi
      </h2>
      
      {loadingAttendance ? (
        <div style={styles.loading}>
          <div style={styles.spinner}></div>
          <p>Yoklama verileri yükleniyor...</p>
        </div>
      ) : (
        <>
          {/* Yoklama İstatistikleri */}
          <div style={styles.attendanceStatsSection}>
            <h3 style={styles.sectionTitle}>Yoklama İstatistikleri</h3>
            <div style={styles.statsGrid}>
              <div style={styles.statCard}>
                <div style={styles.statIcon}>📖</div>
                <div style={styles.statContent}>
                  <div style={styles.statNumber}>{courseLessons.length}</div>
                  <div style={styles.statLabel}>Toplam Ders</div>
                </div>
              </div>
              <div style={styles.statCard}>
                <div style={styles.statIcon}>📋</div>
                <div style={styles.statContent}>
                  <div style={styles.statNumber}>{attendanceStats.totalAttendanceRecords}</div>
                  <div style={styles.statLabel}>Yoklama Kaydı</div>
                </div>
              </div>
              <div style={styles.statCard}>
                <div style={styles.statIcon}>👥</div>
                <div style={styles.statContent}>
                  <div style={styles.statNumber}>{enrolledStudents.length}</div>
                  <div style={styles.statLabel}>Kayıtlı Öğrenci</div>
                </div>
              </div>
              <div style={styles.statCard}>
                <div style={styles.statIcon}>📈</div>
                <div style={styles.statContent}>
                  <div style={styles.statNumber}>{attendanceStats.averageAttendance}%</div>
                  <div style={styles.statLabel}>Ortalama Katılım</div>
                </div>
              </div>
            </div>
          </div>

          {/* Öğrenci Yoklama Durumları */}
          <div style={styles.studentAttendanceSection}>
            <h3 style={styles.sectionTitle}>Öğrenci Katılım Durumları</h3>
            {enrolledStudents.length === 0 ? (
              <div style={styles.emptyState}>
                Kayıtlı öğrenci bulunmuyor.
              </div>
            ) : (
              <div style={styles.tableContainer}>
                <table style={styles.table}>
                  <thead>
                    <tr>
                      <th style={styles.tableHeader}>Öğrenci</th>
                      <th style={styles.tableHeader}>E-posta</th>
                      <th style={styles.tableHeader}>Katıldı</th>
                      <th style={styles.tableHeader}>Katılmadı</th>
                      <th style={styles.tableHeader}>Katılım Oranı</th>
                      <th style={styles.tableHeader}>Durum</th>
                    </tr>
                  </thead>
                  <tbody>
                    {enrolledStudents.map((student) => {
                      const attendance = calculateStudentAttendance(student._id);
                      return (
                        <tr key={student._id}>
                          <td style={styles.tableCell}>
                            <div style={styles.studentCell}>
                              <div style={styles.studentAvatar}>
                                {student.name?.charAt(0).toUpperCase() || '?'}
                              </div>
                              <div style={styles.studentInfoCell}>
                                <div style={styles.studentName}>{student.name}</div>
                                <div style={styles.studentId}>ID: {student._id.slice(-6)}</div>
                              </div>
                            </div>
                          </td>
                          <td style={styles.tableCell}>{student.email}</td>
                          <td style={styles.tableCell}>
                            <span style={styles.presentBadge}>
                              {attendance.present}
                            </span>
                          </td>
                          <td style={styles.tableCell}>
                            <span style={styles.absentBadge}>
                              {attendance.absent}
                            </span>
                          </td>
                          <td style={styles.tableCell}>
                            <div style={styles.attendanceBarContainer}>
                              <div style={styles.attendanceBar}>
                                <div style={styles.attendanceBarFill(attendance.percentage)}></div>
                              </div>
                              <span style={styles.percentageText}>
                                %{attendance.percentage}
                              </span>
                            </div>
                          </td>
                          <td style={styles.tableCell}>
                            <span style={styles.statusBadge(attendance.percentage)}>
                              {attendance.percentage >= 80 ? 'İyi' : 
                               attendance.percentage >= 60 ? 'Orta' : 
                               'Zayıf'}
                            </span>
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>
            )}
          </div>

          {/* Son Yoklama Kayıtları */}
          <div style={styles.recentAttendanceSection}>
            <h3 style={styles.sectionTitle}>Son Yoklama Kayıtları</h3>
            {courseAttendance.length === 0 ? (
              <div style={styles.emptyState}>
                Henüz yoklama kaydı bulunmuyor.
              </div>
            ) : (
              <div style={styles.attendanceHistory}>
                {courseAttendance.slice(0, 5).map((record) => {
                  const lesson = courseLessons.find(l => l._id === record.lessonId);
                  const presentCount = record.attendance ? 
                    Object.values(record.attendance).filter(status => status === 'present').length : 0;
                  const totalCount = record.attendance ? 
                    Object.keys(record.attendance).length : 0;
                  
                  return (
                    <div key={record._id} style={styles.attendanceRecordCard}>
                      <div style={styles.recordHeader}>
                        <div style={styles.recordInfo}>
                          <div style={styles.recordTitle}>
                            {lesson ? lesson.title : 'Bilinmeyen Ders'}
                          </div>
                          <div style={styles.recordDate}>
                            📅 {new Date(record.date).toLocaleDateString('tr-TR')}
                          </div>
                        </div>
                        <div style={styles.recordStats}>
                          <span style={styles.recordStat}>
                            👥 {presentCount}/{totalCount}
                          </span>
                          <span style={styles.recordStat}>
                            📊 %{Math.round((presentCount / (totalCount || 1)) * 100)}
                          </span>
                        </div>
                      </div>
                      <div style={styles.recordActions}>
                        <button 
                          style={styles.viewDetailsButton}
                          onClick={() => {
                            alert(`Yoklama detayları:\nKatılan: ${presentCount}\nKatılmayan: ${totalCount - presentCount}`);
                          }}
                        >
                          Detayları Gör
                        </button>
                      </div>
                    </div>
                  );
                })}
                {courseAttendance.length > 5 && (
                  <div style={styles.viewAllContainer}>
                    <button style={styles.viewAllButton}>
                      Tüm Kayıtları Gör ({courseAttendance.length})
                    </button>
                  </div>
                )}
              </div>
            )}
          </div>
        </>
      )}
    </div>
  );

  // YOKLAMA MODALI - DÜZELTİLMİŞ
  const renderAttendanceModal = () => {
    console.log("Modal render ediliyor");
    console.log("selectedLessonForAttendance:", selectedLessonForAttendance);
    console.log("courseLessons:", courseLessons);
    
    if (!selectedLessonForAttendance) {
      console.error("selectedLessonForAttendance null");
      return null;
    }
    
    const currentLesson = courseLessons.find(l => l._id === selectedLessonForAttendance);
    console.log("currentLesson:", currentLesson);
    
    if (!currentLesson) {
      console.error("Ders bulunamadı!");
      return (
        <div style={styles.modalOverlay} onClick={() => setShowAttendanceModal(false)}>
          <div style={styles.modalContent} onClick={(e) => e.stopPropagation()}>
            <div style={styles.modalHeader}>
              <h3 style={styles.modalTitle}>Hata</h3>
              <button onClick={() => setShowAttendanceModal(false)} style={styles.closeButton}>✕</button>
            </div>
            <div style={{padding: '20px', textAlign: 'center'}}>
              <p>Ders bulunamadı. Lütfen sayfayı yenileyin.</p>
              <button onClick={() => setShowAttendanceModal(false)} style={styles.cancelButton}>Kapat</button>
            </div>
          </div>
        </div>
      );
    }
    
    const presentCount = Object.values(attendanceStatus).filter(status => status === 'present').length;
    const absentCount = Object.values(attendanceStatus).filter(status => status === 'absent').length;
    
    return (
      <div style={styles.modalOverlay} onClick={() => setShowAttendanceModal(false)}>
        <div style={styles.modalContent} onClick={(e) => e.stopPropagation()}>
          <div style={styles.modalHeader}>
            <h3 style={styles.modalTitle}>
              📋 Yoklama Al
              <span style={styles.modalSubtitle}>
                - {currentLesson.title}
              </span>
            </h3>
            <button 
              onClick={() => setShowAttendanceModal(false)}
              style={styles.closeButton}
            >
              ✕
            </button>
          </div>
          <div style={styles.attendanceSummary}>
            <div style={styles.summaryCard}>
              <div style={styles.summaryIcon}>📋</div>
              <div style={styles.summaryContent}>
                <div style={styles.summaryTitle}>{currentLesson?.title}</div>
                <div style={styles.summaryDate}>
                  {new Date().toLocaleDateString('tr-TR', { 
                    weekday: 'long', 
                    year: 'numeric', 
                    month: 'long', 
                    day: 'numeric' 
                  })}
                </div>
              </div>
            </div>
            
            <div style={styles.attendanceStats}>
              <div style={styles.statCard}>
                <div style={{...styles.statNumber, color: '#28a745'}}>{presentCount}</div>
                <div style={styles.statLabel}>✅ Katıldı</div>
              </div>
              <div style={styles.statCard}>
                <div style={{...styles.statNumber, color: '#dc3545'}}>{absentCount}</div>
                <div style={styles.statLabel}>❌ Katılmadı</div>
              </div>
              <div style={styles.statCard}>
                <div style={styles.statNumber}>{enrolledStudents.length}</div>
                <div style={styles.statLabel}>👥 Toplam</div>
              </div>
            </div>
          </div>
          
          <div style={styles.stepInstructions}>
            <p style={styles.instructionText}>
              Kayıtlı öğrenciler listelenir. Katılmayanları "Katılmadı" olarak işaretleyin.
            </p>
          </div>

          <div style={styles.attendanceList}>
            <div style={styles.attendanceListHeader}>
              <span style={styles.attendanceListHeaderTitle}>Öğrenci</span>
              <span style={styles.attendanceListHeaderStatus}>Durum</span>
            </div>
            
            {enrolledStudents.map((student) => {
              const isPresent = attendanceStatus[student._id] === 'present';
              const isAbsent = attendanceStatus[student._id] === 'absent';
              
              return (
                <div key={student._id} style={styles.attendanceItem}>
                  <div style={styles.studentInfo}>
                    <div style={styles.studentAvatar}>
                      {student.name?.charAt(0).toUpperCase() || '?'}
                    </div>
                    <div style={styles.studentDetails}>
                      <div style={styles.studentName}>{student.name}</div>
                      <div style={styles.studentEmail}>{student.email}</div>
                      <div style={styles.statusIndicator}>
                        {isPresent && <span style={styles.presentStatus}>✓ Katıldı</span>}
                        {isAbsent && <span style={styles.absentStatus}>✗ Katılmadı</span>}
                      </div>
                    </div>
                  </div>
                  
                  <div style={styles.attendanceToggle}>
                    <button
                      type="button"
                      onClick={() => handleAttendanceChange(student._id, 'present')}
                      style={isPresent ? styles.presentButtonActive : styles.presentButtonInactive}
                    >
                      ✓ Katıldı
                    </button>
                    
                    <button
                      type="button"
                      onClick={() => handleAttendanceChange(student._id, 'absent')}
                      style={isAbsent ? styles.absentButtonActive : styles.absentButtonInactive}
                    >
                      ✗ Katılmadı
                    </button>
                  </div>
                </div>
              );
            })}
          </div>
          
          <div style={styles.modalActions}>
            <button
              onClick={() => setShowAttendanceModal(false)}
              style={styles.cancelButton}
            >
              İptal
            </button>
            
            <div style={styles.modalRightActions}>
              <div style={styles.attendanceWarning}>
                {presentCount === 0 && absentCount === 0 ? (
                  <span style={styles.warningText}>⚠️ Lütfen en az bir öğrenci için durum seçin</span>
                ) : presentCount === 0 ? (
                  <span style={styles.warningText}>⚠️ Hiç katılan öğrenci yok</span>
                ) : absentCount === 0 ? (
                  <span style={styles.infoText}>ℹ️ Tüm öğrenciler katıldı</span>
                ) : (
                  <span style={styles.successText}>✓ {presentCount} katıldı, ✗ {absentCount} katılmadı</span>
                )}
              </div>
              
              <button
                onClick={handleSaveAttendance}
                disabled={attendanceLoading || (presentCount === 0 && absentCount === 0)}
                style={styles.saveButton}
              >
                {attendanceLoading ? 'Kaydediliyor...' : `📋 Yoklamayı Kaydet (${presentCount} Katıldı, ${absentCount} Katılmadı)`}
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  };

  if (loading && myCourses.length === 0) {
    return (
      <div style={styles.loading}>
        <div style={styles.spinner}></div>
        <p>Yükleniyor...</p>
      </div>
    );
  }

  return (
    <div style={styles.container}>
      <div style={styles.header}>
        <h1 style={styles.headerTitle}>
          Eğitmen Paneli
          {selectedCourse && (
            <span style={styles.courseTitle}>
              - {selectedCourse.title}
            </span>
          )}
        </h1>
      </div>
      
      <div style={styles.tabs}>
        <button
          style={styles.tabButton(activeTab === "courses")}
          onClick={() => setActiveTab("courses")}
        >
          📚 Kurslarım
        </button>
        {selectedCourse && (
          <>
            <button
              style={styles.tabButton(activeTab === "lessons")}
              onClick={() => setActiveTab("lessons")}
            >
              📖 Dersler ({courseLessons.length})
            </button>
            <button
              style={styles.tabButton(activeTab === "students")}
              onClick={() => setActiveTab("students")}
            >
              👥 Öğrenciler ({enrolledStudents.length})
            </button>
            <button
              style={styles.tabButton(activeTab === "assignments")}
              onClick={() => setActiveTab("assignments")}
            >
              📝 Ödevler ({assignments.length})
            </button>
            <button
              style={styles.tabButton(activeTab === "assign-student")}
              onClick={() => setActiveTab("assign-student")}
            >
              👤 Öğrenci Ata
            </button>
            <button
              style={styles.tabButton(activeTab === "attendance")}
              onClick={() => setActiveTab("attendance")}
            >
              📊 Yoklama Takibi
            </button>
            <button
              style={styles.tabButton(activeTab === "add-lesson")}
              onClick={() => setActiveTab("add-lesson")}
            >
              ➕ Ders Ekle
            </button>
          </>
        )}
      </div>

      {activeTab === "courses" && (
        <div style={styles.card}>
          <h2 style={styles.cardTitle}>Kurslarım ({myCourses.length})</h2>
          {myCourses.length === 0 ? (
            <div style={styles.emptyState}>
              Size atanan kurs bulunmuyor.
            </div>
          ) : (
            <div style={styles.courseList}>
              {myCourses.map((course) => (
                <div 
                  key={course._id} 
                  style={styles.courseCard(selectedCourse?._id === course._id)}
                  onClick={() => handleCourseSelect(course)}
                >
                  <div style={styles.courseContent}>
                    <h4 style={styles.courseName}>{course.title}</h4>
                    <p style={styles.courseDescription}>{course.description}</p>
                    <div style={styles.courseMeta}>
                      <span>📅 {course.duration}</span>
                      <span>📊 {course.level}</span>
                      <span>💰 ₺{course.price}</span>
                    </div>
                  </div>
                  <div style={styles.selectButton}>
                    Seç →
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      )}

      {activeTab === "lessons" && selectedCourse && renderLessonsTab()}

      {activeTab === "students" && selectedCourse && (
        <div style={styles.card}>
          <h2 style={styles.cardTitle}>
            {selectedCourse.title} - Kayıtlı Öğrenciler ({enrolledStudents.length})
          </h2>
          {enrolledStudents.length === 0 ? (
            <div style={styles.emptyState}>
              Bu kursa henüz kayıt olan öğrenci bulunmuyor.
            </div>
          ) : (
            <div style={styles.tableContainer}>
              <table style={styles.table}>
                <thead>
                  <tr>
                    <th style={styles.tableHeader}>Öğrenci Adı</th>
                    <th style={styles.tableHeader}>E-posta</th>
                    <th style={styles.tableHeader}>Kayıt Tarihi</th>
                    <th style={styles.tableHeader}>İlerleme</th>
                    <th style={styles.tableHeader}>Katılım</th>
                  </tr>
                </thead>
                <tbody>
                  {enrolledStudents.map((student) => {
                    const attendance = calculateStudentAttendance(student._id);
                    return (
                      <tr key={student._id}>
                        <td style={styles.tableCell}>{student.name}</td>
                        <td style={styles.tableCell}>{student.email}</td>
                        <td style={styles.tableCell}>
                          {student.enrolledAt ? new Date(student.enrolledAt).toLocaleDateString("tr-TR") : "N/A"}
                        </td>
                        <td style={styles.tableCell}>
                          <span style={styles.activeBadge}>
                            Aktif
                          </span>
                        </td>
                        <td style={styles.tableCell}>
                          <span style={styles.attendancePercentageBadge(attendance.percentage)}>
                            %{attendance.percentage}
                          </span>
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          )}
        </div>
      )}

      {activeTab === "assign-student" && selectedCourse && (
        <div style={styles.card}>
          <h2 style={styles.cardTitle}>{selectedCourse.title} - Öğrenci Ata</h2>
          <form onSubmit={handleAssignStudent} style={styles.form}>
            <div style={styles.formGroup}>
              <label style={styles.formLabel}>Öğrenci E-posta</label>
              <input
                type="email"
                value={assignEmail}
                onChange={(e) => setAssignEmail(e.target.value)}
                required
                style={styles.formInput}
                placeholder="ornek@email.com"
              />
              <small style={styles.formHint}>
                Sisteme kayıtlı öğrencinin e-posta adresini girin.
              </small>
            </div>
            <button type="submit" disabled={loading} style={styles.submitButton}>
              {loading ? "Atanıyor..." : "Öğrenci Ata"}
            </button>
          </form>
        </div>
      )}

      {activeTab === "attendance" && selectedCourse && renderAttendanceSection()}

      {activeTab === "assignments" && selectedCourse && (
        <div style={styles.card}>
          <h2 style={styles.cardTitle}>{selectedCourse.title} - Ödevler</h2>
          
          <div style={styles.assignmentsSection}>
            <h3 style={styles.sectionTitle}>Mevcut Ödevler</h3>
            {assignments.length === 0 ? (
              <div style={styles.emptyState}>
                Henüz ödev yok.
              </div>
            ) : (
              <div>
                {assignments.map(assignment => (
                  <div key={assignment._id} style={styles.assignmentCard}>
                    <div style={styles.assignmentHeader}>
                      <div style={styles.assignmentContent}>
                        <h4 style={styles.assignmentTitle}>{assignment.title}</h4>
                        <p style={styles.assignmentDescription}>{assignment.description}</p>
                        <div style={styles.assignmentMeta}>
                          {assignment.dueDate && (
                            <span>📅 <strong>Son Tarih:</strong> {new Date(assignment.dueDate).toLocaleDateString("tr-TR")}</span>
                          )}
                          {assignment.assignedTo && assignment.assignedTo.length > 0 && (
                            <span>👥 <strong>Atanan:</strong> {assignment.assignedTo.length} öğrenci</span>
                          )}
                        </div>
                      </div>
                    </div>

                    <div style={styles.submissionsButtonContainer}>
                      <button 
                        onClick={() => toggleSubmissions(assignment)}
                        style={styles.submissionsButton(viewingSubmissions === assignment._id)}
                      >
                        {viewingSubmissions === assignment._id ? '📂 Teslimleri Gizle' : '📂 Teslimleri Gör'}
                      </button>
                    </div>

                    {viewingSubmissions === assignment._id && (
                      <div style={styles.submissionsContainer}>
                        <h4 style={styles.submissionsTitle}>
                          📋 {assignment.title} - Teslimler
                          {submissions.length > 0 && (
                            <span style={styles.submissionsCount}>
                              {submissions.length} teslim
                            </span>
                          )}
                        </h4>
                        
                        {submissionLoading ? (
                          <div style={styles.loading}>
                            <div style={styles.spinner}></div>
                            Teslimler yükleniyor...
                          </div>
                        ) : submissions.length === 0 ? (
                          <div style={styles.emptyState}>
                            Henüz teslim yok.
                          </div>
                        ) : (
                          <div style={styles.submissionsList}>
                            {submissions.map(submission => (
                              <div key={submission._id} style={styles.submissionCard}>
                                <div style={styles.submissionHeader}>
                                  <div style={styles.submissionInfo}>
                                    <div style={styles.studentEmail}>{submission.studentEmail}</div>
                                    <div style={styles.submissionDate}>
                                      📅 Teslim Tarihi: {submission.submittedAt ? new Date(submission.submittedAt).toLocaleString('tr-TR') : 'N/A'}
                                    </div>
                                  </div>
                                  <div style={styles.submissionActions}>
                                    {submission.grade !== null && (
                                      <div style={styles.gradeBadge}>
                                        Not: {submission.grade}
                                      </div>
                                    )}
                                    {submission.fileUrl && (
                                      <a 
                                        href={submission.fileUrl} 
                                        target='_blank' 
                                        rel='noreferrer' 
                                        style={styles.fileLink}
                                      >
                                        📎 Dosyayı Görüntüle
                                      </a>
                                    )}
                                  </div>
                                </div>
                                
                                {submission.content && (
                                  <div style={styles.submissionContent}>
                                    {submission.content}
                                  </div>
                                )}

                                <div style={styles.gradingForm}>
                                  <div style={styles.gradingGrid}>
                                    <div>
                                      <label style={styles.gradingLabel}>Not</label>
                                      <input 
                                        type="number" 
                                        placeholder="Not" 
                                        value={gradeInputs[submission._id]?.grade ?? ''} 
                                        onChange={e => setGradeInputs(prev => ({ 
                                          ...prev, 
                                          [submission._id]: { ...prev[submission._id], grade: e.target.value } 
                                        }))} 
                                        style={styles.gradingInput} 
                                      />
                                    </div>
                                    <div>
                                      <label style={styles.gradingLabel}>Geri Bildirim</label>
                                      <input 
                                        placeholder="Geri bildirim" 
                                        value={gradeInputs[submission._id]?.feedback ?? ''} 
                                        onChange={e => setGradeInputs(prev => ({ 
                                          ...prev, 
                                          [submission._id]: { ...prev[submission._id], feedback: e.target.value } 
                                        }))} 
                                        style={styles.gradingInput} 
                                      />
                                    </div>
                                    <button 
                                      onClick={() => handleGrade(submission._id)} 
                                      style={styles.saveGradeButton}
                                    >
                                      Kaydet
                                    </button>
                                  </div>
                                </div>
                              </div>
                            ))}
                          </div>
                        )}
                      </div>
                    )}
                  </div>
                ))}
              </div>
            )}
          </div>

          <div style={styles.createAssignmentSection}>
            <h3 style={styles.sectionTitle}>Yeni Ödev Oluştur</h3>
            <form onSubmit={handleCreateAssignment} style={styles.createForm}>
              <div style={styles.formGrid}>
                <div style={styles.formGroup}>
                  <label style={styles.formLabel}>Başlık</label>
                  <input 
                    required 
                    placeholder="Ödev başlığı" 
                    value={newAssignment.title} 
                    onChange={e => setNewAssignment({ ...newAssignment, title: e.target.value })} 
                    style={styles.formInput} 
                  />
                </div>
                <div style={styles.formGroup}>
                  <label style={styles.formLabel}>Açıklama</label>
                  <textarea 
                    placeholder="Ödev açıklaması" 
                    value={newAssignment.description} 
                    onChange={e => setNewAssignment({ ...newAssignment, description: e.target.value })} 
                    rows={4} 
                    style={styles.formTextarea} 
                  />
                </div>
                <div style={styles.formGrid2}>
                  <div style={styles.formGroup}>
                    <label style={styles.formLabel}>Son Teslim Tarihi</label>
                    <input 
                      type="date" 
                      value={newAssignment.dueDate} 
                      onChange={e => setNewAssignment({ ...newAssignment, dueDate: e.target.value })} 
                      style={styles.formInput} 
                    />
                  </div>
                </div>
                <div>
                  <button 
                    type="submit" 
                    disabled={loading} 
                    style={styles.createAssignmentButton}
                  >
                    {loading ? "Oluşturuluyor..." : "✅ Ödev Oluştur"}
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
      )}

      {activeTab === "add-lesson" && selectedCourse && (
        <div style={styles.card}>
          <h2 style={styles.cardTitle}>
            {selectedCourse.title} - Yeni Ders Ekle
          </h2>
          <form onSubmit={handleCreateLesson} style={styles.form}>
            <div style={styles.lessonFormGrid}>
              <div style={styles.formGroup}>
                <label style={styles.formLabel}>Ders Başlığı</label>
                <input
                  type="text"
                  value={newLesson.title}
                  onChange={(e) => setNewLesson({ ...newLesson, title: e.target.value })}
                  style={styles.formInput}
                  required
                />
              </div>
              <div style={styles.formGroup}>
                <label style={styles.formLabel}>Ders Açıklaması</label>
                <textarea
                  value={newLesson.description}
                  onChange={(e) => setNewLesson({ ...newLesson, description: e.target.value })}
                  rows="4"
                  style={styles.formTextarea}
                  required
                />
              </div>
              <div style={styles.formGrid3}>
                <div style={styles.formGroup}>
                  <label style={styles.formLabel}>Video URL</label>
                  <input
                    type="url"
                    value={newLesson.videoUrl}
                    onChange={(e) => setNewLesson({ ...newLesson, videoUrl: e.target.value })}
                    placeholder="https://..."
                    style={styles.formInput}
                  />
                </div>
                <div style={styles.formGroup}>
                  <label style={styles.formLabel}>Süre</label>
                  <input
                    type="text"
                    value={newLesson.duration}
                    onChange={(e) => setNewLesson({ ...newLesson, duration: e.target.value })}
                    placeholder="ör: 45 dakika"
                    style={styles.formInput}
                    required
                  />
                </div>
                <div style={styles.formGroup}>
                  <label style={styles.formLabel}>Sıra No</label>
                  <input
                    type="number"
                    value={newLesson.order}
                    onChange={(e) => setNewLesson({ ...newLesson, order: parseInt(e.target.value) })}
                    min="1"
                    style={styles.formInput}
                    required
                  />
                </div>
              </div>
              <button
                type="submit"
                disabled={loading}
                style={styles.submitButton}
              >
                {loading ? "Ekleniyor..." : "Ders Ekle"}
              </button>
            </div>
          </form>
        </div>
      )}

      {showAttendanceModal && renderAttendanceModal()}
    </div>
  );
};

// TÜM STİLLER
const styles = {
  container: {
    maxWidth: '1200px',
    margin: '0 auto',
    padding: 'clamp(4px, 3vw, 32px)',
    fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
    background: '#f7f7f7',
    minHeight: '100vh',
  },
  loading: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    height: '200px',
    color: '#333',
    fontSize: '14px',
  },
  spinner: {
    width: '40px',
    height: '40px',
    border: '3px solid #f3f3f3',
    borderTop: '3px solid #42a947',
    borderRadius: '50%',
    animation: 'spin 1s linear infinite',
    marginBottom: '16px',
  },
  header: {
    marginBottom: 'clamp(16px, 4vw, 32px)',
    paddingBottom: '16px',
    borderBottom: '1px solid #eee',
  },
  headerTitle: {
    fontSize: 'clamp(22px, 5vw, 28px)',
    fontWeight: 'bold',
    color: '#333',
    margin: '0',
  },
  courseTitle: {
    fontSize: 'clamp(15px, 3.5vw, 18px)',
    color: '#666',
    marginLeft: '12px',
    fontWeight: '400',
  },
  tabs: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: '8px',
    marginBottom: 'clamp(16px, 4vw, 32px)',
  },
  tabButton: (isActive) => ({
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    padding: 'clamp(8px, 2vw, 12px) clamp(12px, 3vw, 24px)',
    background: isActive ? '#42a947' : '#fff',
    color: isActive ? 'white' : '#333',
    border: '1px solid #e0e0e0',
    cursor: 'pointer',
    transition: 'all 0.2s ease',
    borderRadius: '8px',
    fontSize: '14px',
    fontWeight: '500',
    whiteSpace: 'nowrap',
    ':hover': {
      background: isActive ? '#42a947' : '#f8f9fa',
    }
  }),
  card: {
    backgroundColor: '#ffffff',
    borderRadius: '12px',
    padding: 'clamp(16px, 4vw, 32px)',
    border: '1px solid #eee',
    boxShadow: '0 2px 10px rgba(0,0,0,0.05)',
  },
  cardTitle: {
    fontSize: '20px',
    fontWeight: '600',
    color: '#333',
    margin: '0 0 24px 0',
  },
  emptyState: {
    textAlign: 'center',
    color: '#666',
    padding: '40px',
    fontSize: '14px',
  },
  courseList: {
    display: 'grid',
    gap: '16px',
  },
  courseCard: (isSelected) => ({
    border: '1px solid #e0e0e0',
    borderRadius: '12px',
    padding: '20px',
    cursor: 'pointer',
    transition: 'all 0.2s ease',
    borderLeft: isSelected ? '4px solid #42a947' : '4px solid transparent',
    display: 'flex',
    flexWrap: 'wrap',
    gap: '12px',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    ':hover': {
      borderColor: '#ced4da',
      boxShadow: '0 2px 8px rgba(0,0,0,0.05)',
    }
  }),
  courseContent: {
    flex: '1 1 220px',
    minWidth: 0,
  },
  courseName: {
    fontSize: '18px',
    fontWeight: '600',
    color: '#333',
    margin: '0 0 12px 0',
  },
  courseDescription: {
    fontSize: '14px',
    color: '#555',
    lineHeight: '1.5',
    margin: '0 0 12px 0',
  },
  courseMeta: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: '8px 16px',
    fontSize: '12px',
    color: '#666',
  },
  selectButton: {
    background: '#f8f9fa',
    padding: '8px 12px',
    borderRadius: '6px',
    fontSize: '12px',
    color: '#42a947',
    border: '1px solid #e0e0e0',
  },
  lessonsList: {
    display: 'grid',
    gap: '12px',
  },
  lessonCard: {
    border: '1px solid #e0e0e0',
    borderRadius: '12px',
    padding: 'clamp(14px, 3vw, 20px)',
    display: 'flex',
    flexWrap: 'wrap',
    gap: '12px',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  lessonContent: {
    flex: '1 1 240px',
    minWidth: 0,
  },
  lessonHeader: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: '8px',
    alignItems: 'center',
    marginBottom: '12px',
  },
  lessonNumber: {
    background: '#f8f9fa',
    color: '#333',
    borderRadius: '50%',
    width: '32px',
    height: '32px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: '14px',
    fontWeight: '500',
    border: '1px solid #e0e0e0',
    flexShrink: 0,
  },
  lessonTitle: {
    fontSize: '16px',
    fontWeight: '500',
    color: '#333',
    margin: '0',
  },
  lessonDescription: {
    fontSize: '14px',
    color: '#555',
    margin: '0 0 12px 0',
  },
  lessonMeta: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: '8px 16px',
    fontSize: '12px',
    color: '#666',
  },
  lessonActions: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: '8px',
    alignItems: 'center',
  },
  deleteButton: {
    background: '#dc3545',
    color: 'white',
    border: 'none',
    padding: '8px 16px',
    borderRadius: '6px',
    cursor: 'pointer',
    fontSize: '14px',
    fontWeight: '500',
    transition: 'all 0.2s ease',
    ':hover': {
      backgroundColor: '#c82333',
    }
  },
  attendanceButton: {
    background: '#0066cc',
    color: 'white',
    border: 'none',
    padding: '8px 16px',
    borderRadius: '6px',
    cursor: 'pointer',
    fontSize: '14px',
    fontWeight: '500',
    transition: 'all 0.2s ease',
    ':hover': {
      backgroundColor: '#0052a3',
    }
  },
  attendanceBadge: {
    background: '#e7f4ff',
    color: '#0066cc',
    padding: '4px 10px',
    borderRadius: '12px',
    fontSize: '12px',
    fontWeight: '500',
    border: '1px solid #b3d9ff',
    display: 'flex',
    alignItems: 'center',
    gap: '4px',
  },
  attendanceSystemBadge: {
    background: '#e7f4ff',
    color: '#0066cc',
    padding: '4px 12px',
    borderRadius: '12px',
    fontSize: '14px',
    fontWeight: '500',
    marginLeft: '12px',
    border: '1px solid #b3d9ff',
  },
  tableContainer: {
    overflowX: 'auto',
  },
  table: {
    width: '100%',
    borderCollapse: 'collapse',
  },
  tableHeader: {
    backgroundColor: '#f8f9fa',
    padding: '16px',
    textAlign: 'left',
    fontWeight: '600',
    color: '#333',
    borderBottom: '1px solid #e0e0e0',
    fontSize: '14px',
    whiteSpace: 'nowrap',
  },
  tableCell: {
    padding: 'clamp(10px, 2.5vw, 16px)',
    borderBottom: '1px solid #f0f0f0',
    fontSize: '14px',
    color: '#333',
    whiteSpace: 'nowrap',
  },
  activeBadge: {
    background: '#28a745',
    color: 'white',
    padding: '4px 8px',
    borderRadius: '4px',
    fontSize: '12px',
    fontWeight: '500',
  },
  form: {
    maxWidth: '600px',
  },
  formGroup: {
    marginBottom: '16px',
  },
  formLabel: {
    display: 'block',
    marginBottom: '8px',
    fontWeight: '500',
    color: '#333',
    fontSize: '14px',
  },
  formInput: {
    width: '100%',
    padding: '10px 12px',
    border: '1px solid #e0e0e0',
    borderRadius: '8px',
    fontSize: '14px',
    background: '#f8f9fa',
    transition: 'border-color 0.2s',
    ':focus': {
      outline: 'none',
      borderColor: '#42a947',
    }
  },
  formTextarea: {
    width: '100%',
    padding: '10px 12px',
    border: '1px solid #e0e0e0',
    borderRadius: '8px',
    fontSize: '14px',
    background: '#f8f9fa',
    minHeight: '100px',
    resize: 'vertical',
    fontFamily: 'inherit',
    transition: 'border-color 0.2s',
    ':focus': {
      outline: 'none',
      borderColor: '#42a947',
    }
  },
  submitButton: {
    background: '#42a947',
    color: 'white',
    border: 'none',
    padding: '12px 24px',
    borderRadius: '6px',
    cursor: 'pointer',
    fontSize: '14px',
    fontWeight: '500',
    transition: 'background 0.2s ease',
    ':hover': {
      backgroundColor: '#3a8a4a',
    },
    ':disabled': {
      backgroundColor: '#6c757d',
      cursor: 'not-allowed',
    }
  },
  assignmentsSection: {
    marginBottom: '32px',
  },
  sectionTitle: {
    fontSize: '18px',
    fontWeight: '600',
    color: '#333',
    marginBottom: '16px',
  },
  assignmentCard: {
    border: '1px solid #e0e0e0',
    padding: 'clamp(16px, 4vw, 24px)',
    borderRadius: '12px',
    marginBottom: '20px',
    background: '#fff',
  },
  assignmentHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    marginBottom: '20px',
  },
  assignmentContent: {
    flex: 1,
  },
  assignmentTitle: {
    fontSize: '18px',
    fontWeight: '600',
    color: '#333',
    margin: '0 0 12px 0',
  },
  assignmentDescription: {
    fontSize: '14px',
    color: '#555',
    lineHeight: '1.5',
    margin: '0 0 12px 0',
  },
  assignmentMeta: {
    display: 'flex',
    gap: '16px',
    fontSize: '14px',
    color: '#666',
  },
  submissionsButtonContainer: {
    display: 'flex',
    justifyContent: 'flex-start',
    borderTop: '1px solid #f0f0f0',
    paddingTop: '20px',
  },
  submissionsButton: (isActive) => ({
    background: isActive ? '#3a8a4a' : '#42a947',
    color: 'white',
    padding: '10px 20px',
    borderRadius: '6px',
    border: 'none',
    cursor: 'pointer',
    fontSize: '14px',
    fontWeight: '500',
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    transition: 'background 0.2s ease',
    ':hover': {
      backgroundColor: '#3a7a44',
    }
  }),
  submissionsContainer: {
    marginTop: '20px',
    padding: '20px',
    background: '#f8f9fa',
    borderRadius: '12px',
    border: '1px solid #e0e0e0',
  },
  submissionsTitle: {
    fontSize: '16px',
    fontWeight: '600',
    color: '#333',
    marginBottom: '16px',
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
  },
  submissionsCount: {
    background: '#42a947',
    color: 'white',
    padding: '4px 8px',
    borderRadius: '12px',
    fontSize: '12px',
    fontWeight: '500',
  },
  submissionsList: {
    display: 'grid',
    gap: '16px',
  },
  submissionCard: {
    background: '#fff',
    padding: '20px',
    borderRadius: '12px',
    border: '1px solid #e0e0e0',
  },
  submissionHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    marginBottom: '12px',
  },
  submissionInfo: {
    flex: 1,
  },
  studentEmail: {
    fontSize: '16px',
    fontWeight: '500',
    color: '#333',
    marginBottom: '4px',
  },
  submissionDate: {
    fontSize: '14px',
    color: '#666',
  },
  submissionActions: {
    textAlign: 'right',
  },
  gradeBadge: {
    background: '#28a745',
    color: 'white',
    padding: '4px 8px',
    borderRadius: '4px',
    fontSize: '14px',
    fontWeight: '500',
    marginBottom: '8px',
  },
  fileLink: {
    display: 'block',
    color: '#42a947',
    textDecoration: 'none',
    fontSize: '14px',
    ':hover': {
      textDecoration: 'underline',
    }
  },
  submissionContent: {
    background: '#f8f9fa',
    padding: '12px',
    borderRadius: '6px',
    fontSize: '14px',
    lineHeight: '1.5',
    color: '#333',
    marginBottom: '16px',
  },
  gradingForm: {
    background: '#fff',
    padding: '16px',
    borderRadius: '8px',
    border: '1px solid #e0e0e0',
  },
  gradingGrid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(min(100%, 120px), 1fr))',
    gap: '12px',
    alignItems: 'end',
  },
  gradingLabel: {
    display: 'block',
    marginBottom: '4px',
    fontSize: '14px',
    fontWeight: '500',
    color: '#333',
  },
  gradingInput: {
    width: '100%',
    padding: '8px',
    border: '1px solid #e0e0e0',
    borderRadius: '6px',
    fontSize: '14px',
    background: '#f8f9fa',
  },
  saveGradeButton: {
    background: '#28a745',
    color: 'white',
    border: 'none',
    padding: '8px 16px',
    borderRadius: '6px',
    cursor: 'pointer',
    fontSize: '14px',
    fontWeight: '500',
    ':hover': {
      backgroundColor: '#218838',
    }
  },
  createAssignmentSection: {
    borderTop: '2px solid #f0f0f0',
    paddingTop: '24px',
  },
  createForm: {
    width: '100%',
  },
  formGrid: {
    display: 'grid',
    gap: '16px',
  },
  formGrid2: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(min(100%, 220px), 1fr))',
    gap: '16px',
  },
  formGrid3: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(min(100%, 160px), 1fr))',
    gap: '16px',
  },
  createAssignmentButton: {
    background: '#28a745',
    color: 'white',
    border: 'none',
    padding: '12px 32px',
    borderRadius: '6px',
    cursor: 'pointer',
    fontSize: '14px',
    fontWeight: '500',
    ':hover': {
      backgroundColor: '#218838',
    },
    ':disabled': {
      backgroundColor: '#6c757d',
      cursor: 'not-allowed',
    }
  },
  lessonFormGrid: {
    display: 'grid',
    gap: '16px',
    maxWidth: '600px',
  },
  
  // MODAL STYLES
  modalOverlay: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    zIndex: 1000,
  },
  modalContent: {
    background: '#fff',
    borderRadius: '16px',
    width: '90%',
    maxWidth: '800px',
    maxHeight: '90vh',
    overflow: 'auto',
    boxShadow: '0 10px 40px rgba(0,0,0,0.2)',
  },
  modalHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '20px 24px',
    borderBottom: '1px solid #eee',
  },
  modalTitle: {
    fontSize: '20px',
    fontWeight: '600',
    color: '#333',
    margin: 0,
  },
  modalSubtitle: {
    fontSize: '16px',
    color: '#666',
    marginLeft: '8px',
    fontWeight: '400',
  },
  closeButton: {
    background: 'none',
    border: 'none',
    fontSize: '20px',
    cursor: 'pointer',
    color: '#666',
    padding: '4px 8px',
    borderRadius: '4px',
    ':hover': {
      background: '#f0f0f0',
    }
  },
  stepIndicator: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '24px',
    background: '#f8f9fa',
  },
  stepItem: (isActive) => ({
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
  }),
  stepCircle: (isActive) => ({
    width: '32px',
    height: '32px',
    borderRadius: '50%',
    background: isActive ? '#42a947' : '#e0e0e0',
    color: isActive ? 'white' : '#666',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: '14px',
    fontWeight: '600',
  }),
  stepLabel: {
    fontSize: '14px',
    fontWeight: '500',
    color: '#333',
  },
  stepDivider: {
    width: '60px',
    height: '2px',
    background: '#e0e0e0',
    margin: '0 16px',
  },
  stepInstructions: {
    padding: '16px 24px',
    background: '#f8f9fa',
    marginBottom: '16px',
  },
  instructionText: {
    fontSize: '14px',
    color: '#666',
    margin: 0,
  },
  studentSelectionHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '0 24px 16px',
  },
  selectionCount: {
    fontSize: '14px',
    color: '#333',
  },
  countText: {
    fontWeight: '600',
    color: '#42a947',
  },
  selectAllButton: {
    background: 'none',
    border: '1px solid #42a947',
    color: '#42a947',
    padding: '6px 12px',
    borderRadius: '6px',
    cursor: 'pointer',
    fontSize: '12px',
    fontWeight: '500',
    ':hover': {
      background: '#f0f9f0',
    }
  },
  studentSelectionList: {
    maxHeight: '300px',
    overflow: 'auto',
    padding: '0 24px',
  },
  studentSelectionItem: (isSelected) => ({
    display: 'flex',
    alignItems: 'center',
    gap: '12px',
    padding: '12px',
    borderRadius: '8px',
    cursor: 'pointer',
    background: isSelected ? '#f0f9f0' : '#fff',
    border: '1px solid #e0e0e0',
    marginBottom: '8px',
    transition: 'all 0.2s ease',
    ':hover': {
      background: '#f8f9fa',
    }
  }),
  checkbox: {
    width: '18px',
    height: '18px',
    cursor: 'pointer',
  },
  studentInfo: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
  },
  studentName: {
    fontSize: '14px',
    fontWeight: '500',
    color: '#333',
  },
  studentEmail: {
    fontSize: '12px',
    color: '#666',
  },
  studentDetails: {
    marginLeft: '8px',
  },
  selectionStatus: {
    fontSize: '12px',
    color: '#42a947',
    fontWeight: '500',
  },
  modalActions: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: '12px',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '20px clamp(12px, 4vw, 24px)',
    borderTop: '1px solid #eee',
  },
  modalRightActions: {
    display: 'flex',
    gap: '16px',
    alignItems: 'center',
  },
  cancelButton: {
    background: '#f8f9fa',
    border: '1px solid #e0e0e0',
    color: '#333',
    padding: '10px 24px',
    borderRadius: '8px',
    cursor: 'pointer',
    fontSize: '14px',
    fontWeight: '500',
    ':hover': {
      background: '#e0e0e0',
    }
  },
  nextStepButton: {
    background: '#42a947',
    color: 'white',
    border: 'none',
    padding: '10px 24px',
    borderRadius: '8px',
    cursor: 'pointer',
    fontSize: '14px',
    fontWeight: '500',
    ':hover': {
      background: '#3a8a4a',
    },
    ':disabled': {
      background: '#6c757d',
      cursor: 'not-allowed',
    }
  },
  backButton: {
    background: '#f8f9fa',
    border: '1px solid #e0e0e0',
    color: '#333',
    padding: '10px 24px',
    borderRadius: '8px',
    cursor: 'pointer',
    fontSize: '14px',
    fontWeight: '500',
    ':hover': {
      background: '#e0e0e0',
    }
  },
  
  // YOKLAMA İSTATİSTİKLERİ STYLES
  attendanceStatsSection: {
    marginBottom: '32px',
    padding: '24px',
    background: '#f8f9fa',
    borderRadius: '12px',
  },
  statsGrid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(min(100%, 150px), 1fr))',
    gap: 'clamp(12px, 3vw, 20px)',
    marginTop: '16px',
  },
  statCard: {
    display: 'flex',
    alignItems: 'center',
    padding: '20px',
    background: '#fff',
    borderRadius: '12px',
    border: '1px solid #e0e0e0',
  },
  statIcon: {
    fontSize: 'clamp(24px, 6vw, 32px)',
    marginRight: '12px',
  },
  statContent: {
    flex: 1,
  },
  statNumber: {
    fontSize: '28px',
    fontWeight: 'bold',
    color: '#333',
    lineHeight: '1.2',
    marginBottom: '4px',
  },
  statLabel: {
    fontSize: '14px',
    color: '#666',
  },
  studentAttendanceSection: {
    marginBottom: '32px',
  },
  studentCell: {
    display: 'flex',
    alignItems: 'center',
    gap: '12px',
  },
  studentAvatar: {
    width: '32px',
    height: '32px',
    background: '#42a947',
    color: 'white',
    borderRadius: '50%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: '14px',
    fontWeight: '500',
  },
  studentInfoCell: {
    display: 'flex',
    flexDirection: 'column',
  },
  studentId: {
    fontSize: '12px',
    color: '#666',
  },
  presentBadge: {
    background: '#d4edda',
    color: '#155724',
    padding: '4px 12px',
    borderRadius: '12px',
    fontSize: '14px',
    fontWeight: '500',
  },
  absentBadge: {
    background: '#f8d7da',
    color: '#721c24',
    padding: '4px 12px',
    borderRadius: '12px',
    fontSize: '14px',
    fontWeight: '500',
  },
  attendanceBarContainer: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
  },
  attendanceBar: {
    width: '80px',
    height: '8px',
    backgroundColor: '#e0e0e0',
    borderRadius: '4px',
    overflow: 'hidden',
  },
  attendanceBarFill: (percentage) => ({
    width: `${percentage}%`,
    height: '100%',
    backgroundColor: percentage >= 80 ? '#28a745' : percentage >= 60 ? '#ffc107' : '#dc3545',
    transition: 'width 0.3s ease',
  }),
  percentageText: {
    fontSize: '14px',
    fontWeight: '600',
    color: '#333',
  },
  statusBadge: (percentage) => ({
    padding: '4px 12px',
    borderRadius: '12px',
    fontSize: '12px',
    fontWeight: '500',
    backgroundColor: percentage >= 80 ? '#d4edda' : percentage >= 60 ? '#fff3cd' : '#f8d7da',
    color: percentage >= 80 ? '#155724' : percentage >= 60 ? '#856404' : '#721c24',
  }),
  recentAttendanceSection: {
    marginTop: '32px',
  },
  attendanceHistory: {
    display: 'grid',
    gap: '12px',
  },
  attendanceRecordCard: {
    border: '1px solid #e0e0e0',
    padding: '16px',
    borderRadius: '12px',
    background: '#fff',
    display: 'flex',
    flexWrap: 'wrap',
    gap: '12px',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  recordHeader: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: '12px',
    justifyContent: 'space-between',
    alignItems: 'center',
    flex: '1 1 240px',
    minWidth: 0,
  },
  recordInfo: {
    display: 'flex',
    flexDirection: 'column',
    gap: '4px',
  },
  recordTitle: {
    fontSize: '16px',
    fontWeight: '600',
    color: '#333',
  },
  recordDate: {
    fontSize: '12px',
    color: '#666',
  },
  recordStats: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: '8px',
  },
  recordStat: {
    fontSize: '14px',
    color: '#333',
    padding: '4px 8px',
    background: '#f8f9fa',
    borderRadius: '4px',
  },
  recordActions: {
    display: 'flex',
    gap: '8px',
  },
  viewDetailsButton: {
    padding: '6px 12px',
    background: '#fff',
    color: '#42a947',
    border: '1px solid #42a947',
    borderRadius: '6px',
    cursor: 'pointer',
    fontSize: '12px',
    fontWeight: '500',
    ':hover': {
      background: '#f0f9f0',
    }
  },
  viewAllContainer: {
    textAlign: 'center',
    marginTop: '16px',
  },
  viewAllButton: {
    padding: '8px 16px',
    background: 'transparent',
    color: '#0066cc',
    border: '1px solid #0066cc',
    borderRadius: '6px',
    cursor: 'pointer',
    fontSize: '14px',
    fontWeight: '500',
    ':hover': {
      background: '#f0f7ff',
    }
  },
  attendancePercentageBadge: (percentage) => ({
    padding: '4px 8px',
    borderRadius: '12px',
    fontSize: '12px',
    fontWeight: '500',
    backgroundColor: percentage >= 80 ? '#d4edda' : percentage >= 60 ? '#fff3cd' : '#f8d7da',
    color: percentage >= 80 ? '#155724' : percentage >= 60 ? '#856404' : '#721c24',
  }),
  formHint: {
    display: 'block',
    marginTop: '4px',
    fontSize: '12px',
    color: '#666',
  },
  
  // YOKLAMA BUTON STİLLERİ
  presentButtonActive: {
    backgroundColor: '#28a745',
    color: 'white',
    border: 'none',
    padding: '8px 16px',
    borderRadius: '6px',
    cursor: 'pointer',
    fontSize: '13px',
    fontWeight: '600',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '6px',
    minWidth: '100px',
    transition: 'all 0.2s ease',
    ':hover': {
      backgroundColor: '#218838',
    }
  },
  presentButtonInactive: {
    backgroundColor: '#f8f9fa',
    color: '#28a745',
    border: '1px solid #28a745',
    padding: '8px 16px',
    borderRadius: '6px',
    cursor: 'pointer',
    fontSize: '13px',
    fontWeight: '500',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '6px',
    minWidth: '100px',
    transition: 'all 0.2s ease',
    ':hover': {
      backgroundColor: '#f1f8f1',
    }
  },
  absentButtonActive: {
    backgroundColor: '#dc3545',
    color: 'white',
    border: 'none',
    padding: '8px 16px',
    borderRadius: '6px',
    cursor: 'pointer',
    fontSize: '13px',
    fontWeight: '600',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '6px',
    minWidth: '100px',
    transition: 'all 0.2s ease',
    ':hover': {
      backgroundColor: '#c82333',
    }
  },
  absentButtonInactive: {
    backgroundColor: '#f8f9fa',
    color: '#dc3545',
    border: '1px solid #dc3545',
    padding: '8px 16px',
    borderRadius: '6px',
    cursor: 'pointer',
    fontSize: '13px',
    fontWeight: '500',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '6px',
    minWidth: '100px',
    transition: 'all 0.2s ease',
    ':hover': {
      backgroundColor: '#fff5f5',
    }
  },
  presentStatus: {
    backgroundColor: '#d4edda',
    color: '#155724',
    padding: '4px 12px',
    borderRadius: '20px',
    fontSize: '12px',
    fontWeight: '600',
    display: 'inline-block',
  },
  absentStatus: {
    backgroundColor: '#f8d7da',
    color: '#721c24',
    padding: '4px 12px',
    borderRadius: '20px',
    fontSize: '12px',
    fontWeight: '600',
    display: 'inline-block',
  },
  statusIndicator: {
    marginTop: '6px',
  },
  saveButton: {
    backgroundColor: '#42a947',
    color: 'white',
    border: 'none',
    padding: '10px 24px',
    borderRadius: '8px',
    cursor: 'pointer',
    fontSize: '14px',
    fontWeight: '600',
    transition: 'all 0.2s ease',
    minWidth: 'min(200px, 100%)',
    ':hover': {
      backgroundColor: '#3a8a4a',
    },
    ':disabled': {
      backgroundColor: '#6c757d',
      cursor: 'not-allowed',
      opacity: 0.6,
    }
  },
  successText: {
    fontSize: '13px',
    color: '#155724',
    backgroundColor: '#d4edda',
    padding: '8px 16px',
    borderRadius: '8px',
    border: '1px solid #c3e6cb',
    fontWeight: '500',
  },
  warningText: {
    fontSize: '13px',
    color: '#856404',
    backgroundColor: '#fff3cd',
    padding: '8px 16px',
    borderRadius: '8px',
    border: '1px solid #ffeeba',
    fontWeight: '500',
  },
  infoText: {
    fontSize: '13px',
    color: '#004085',
    backgroundColor: '#cce5ff',
    padding: '8px 16px',
    borderRadius: '8px',
    border: '1px solid #b8daff',
    fontWeight: '500',
  },
  attendanceSummary: {
    padding: '16px 24px',
    background: '#f8f9fa',
    borderBottom: '1px solid #e0e0e0',
  },
  summaryCard: {
    display: 'flex',
    alignItems: 'center',
    gap: '16px',
    marginBottom: '16px',
  },
  summaryIcon: {
    fontSize: '32px',
  },
  summaryContent: {
    flex: 1,
  },
  summaryTitle: {
    fontSize: '16px',
    fontWeight: '600',
    color: '#333',
    marginBottom: '4px',
  },
  summaryDate: {
    fontSize: '13px',
    color: '#666',
  },
  attendanceStats: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: '16px',
    justifyContent: 'space-around',
  },
  attendanceList: {
    padding: '16px clamp(12px, 4vw, 24px)',
    maxHeight: '300px',
    overflow: 'auto',
  },
  attendanceListHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    padding: '8px 0',
    borderBottom: '1px solid #e0e0e0',
    marginBottom: '12px',
  },
  attendanceListHeaderTitle: {
    fontSize: '13px',
    fontWeight: '600',
    color: '#333',
  },
  attendanceListHeaderStatus: {
    fontSize: '13px',
    fontWeight: '600',
    color: '#333',
    marginRight: '120px',
  },
  attendanceItem: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: '10px',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '12px',
    borderRadius: '8px',
    background: '#fff',
    border: '1px solid #e0e0e0',
    marginBottom: '8px',
  },
  attendanceToggle: {
    display: 'flex',
    gap: '8px',
  },
  attendanceWarning: {
    marginRight: '16px',
  },
};

// CSS Animasyonu
const styleSheet = document.createElement('style');
styleSheet.textContent = `
  @keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
  }
`;
document.head.appendChild(styleSheet);

export default InstructorPage;
